module.exports = __webpack_public_path__ + "img/studywayIcon8.8a0d0131.png";